import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import {
    Container,
    Row,
    Col,
    Card
} from 'reactstrap';
import styles from './styles.module.scss';
import Link from "next/link"
import SocialShare from '../../components/SocialShare';

export default function FeaturedBlogs({
    global,
    pathPrefix,
    customClass = "",
    content,
    post,
    locale,
    pagePrefix = "blog/",
    socialPagePrefix
}) {
    return (
        post?.length >= 1 && (
            <section className={`${styles.root} ${customClass}`}>
                <Container>
                    <Row className="mb-4">
                        <Col md={6} className="mb-4 mb-md-0">
                            {content ?
                                <SourceFlowText global={global} path={`${pathPrefix}.content`} type="html">
                                    {content}
                                </SourceFlowText>
                                : null}
                        </Col>
                        <Col md={6} className="d-flex justify-content-md-end align-items-center">
                            <p className="mb-0 me-3">Share Our Blog</p>
                            <SocialShare
                                customClass="insights-page-social-share"
                                post={`Insights`}
                                body={``}
                                twitter={true}
                                facebook={true}
                                linkedin={true}
                                email={true}
                                whatsapp={true}
                                urlPrefix={`${locale == "us" ? "us/" : ""}${socialPagePrefix}`}
                                twitterText={`Share on Twitter`}
                                facebookText={`Share on Facebook`}
                                linkedinText={`Share on LinkedIn`}
                            />
                        </Col>
                    </Row>
                    <div>
                        {post.slice(0, 1).map((post, index) =>
                            <Card className={`rounded-4`} key={index}>
                                <Link href={`${locale == "us" ? "/us" : ""}/${pagePrefix}${post.url_slug}/`}>
                                    <a className="d-block h-100">
                                        <Row className="h-100">
                                            <Col lg={8}>
                                                <div className="p-4 h-100 d-flex justify-content-between flex-wrap">
                                                    <div className="w-100">
                                                        <p className="post-title"><strong>{post?.title}</strong></p>
                                                        {post?.short_description ? (
                                                            <div className="post-description" dangerouslySetInnerHTML={{ __html: post?.short_description }} />
                                                        ) : null}
                                                    </div>
                                                    <div className="d-flex align-items-end">
                                                        <div className="mt-4">
                                                            <span>
                                                                Read More
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col lg={4} className="position-relative">
                                                <SourceFlowImage
                                                    src={post?.image ? post.image : "/site-assets/placeholders/img-placeholder.jpg"}
                                                    size="800x500"
                                                    alt={post?.title}
                                                    className="card-img"
                                                    height={`100%`}
                                                    width={`100%`}
                                                />
                                                {post?.tag.length >= 1 && (
                                                    <div className="position-absolute post-tag">
                                                        {post.tag?.map((post, index) => (
                                                            <span className="tertiary-bg text-black d-inline-block px-2 rounded-3 me-2 mb-2 text-nowrap" key={index}>
                                                                {post}
                                                            </span>
                                                        ))}
                                                    </div>
                                                )}
                                            </Col>
                                        </Row>
                                    </a>
                                </Link>
                            </Card>
                        )}
                    </div>
                </Container>
            </section>
        )
    )
}